var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex vh-100 align-items-center justify-content-center"
  }, [_c('button', {
    staticClass: "btn line-push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToOa
    }
  }, [_vm._v(" 返回 LINE 官方帳號 » ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }